module.exports = __webpack_public_path__ + "static/img/sportGame3.b5f2f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/sport/sportGame3.png
// module id = 1uHg
// module chunks = 3